<template>
  <div
    ref="modal"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="staticBackdropLabel">
            {{ $t("videos.videos") }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            :aria-label="$t(`orderChange.close`)"
          ></button>
        </div>
        <div class="modal-body">
          <div v-if="!uploadWindow">
            <div class="row" v-for="(row, key) in rows" :key="key">
              <h3>{{ row.name }}</h3>
              <div>
                <draggable
                  class="dragArea row custom-input pt-2"
                  tag="div"
                  :list="row.images"
                  :group="{ name: 'g1' }"
                  item-key="id"
                  v-bind="dragOptions"
                  :forceFallback="true"
                  :scroll="true"
                  :scrollSensitivity="100"
                  v-on:end="moveEvent(row.id)"
                >
                  <template #item="{ element }">
                    <div class="col-2 my-2 img-uploader-thumbnail">
                      <img
                        class="img-thumbnail"
                        :src="mediaUrl + '/' + element.path + '/frame1.jpg'"
                        :alt="element.name"
                      />
                      <div class="img-btns">
                        <button
                          class="btn btn-outline-primary"
                          v-on:click="deleteVideo(element)"
                        >
                          <BaseIcon name="trash" />
                        </button>
                        <button
                          class="btn spotlight btn-outline-primary"
                          :class="{ active: element.main }"
                          v-on:click="selectSpotlight(element)"
                        >
                          <BaseIcon name="star" />
                        </button>
                        <button
                          class="btn btn-outline-primary"
                          :class="{ active: element.in_page }"
                          v-on:click="
                            selectDisplaySettings(element, 2, !element.in_page)
                          "
                        >
                          <BaseIcon name="shop" />
                        </button>
                        <button
                          class="btn btn-outline-primary"
                          :class="{ active: element.in_meta }"
                          v-on:click="
                            selectDisplaySettings(element, 1, !element.in_meta)
                          "
                        >
                          <BaseIcon name="share" />
                        </button>
                        <button
                          class="btn btn-outline-primary"
                          :class="{ active: element.in_manufacturing }"
                          v-if="isVariant"
                          v-on:click="
                            selectDisplaySettings(
                              element,
                              3,
                              !element.in_manufacturing
                            )
                          "
                        >
                          <BaseIcon name="ruler" />
                        </button>
                      </div>
                    </div>
                  </template>
                  <template #footer>
                    <div class="col-2 my-2">
                      <button
                        class="img-thumbnail"
                        v-on:click="
                          selectedGroup = row;
                          uploadWindow = true;
                        "
                      >
                        <BaseIcon name="plus-circle" />
                      </button>
                    </div>
                  </template>
                </draggable>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="row">
              <div class="col-3 text-start">
                <button
                  class="btn w-100 d-block"
                  v-on:click="uploadMenu = true"
                  :class="{
                    'btn-primary': uploadMenu,
                    'btn-simple': !uploadMenu,
                  }"
                >
                  {{ $t("videos.uploadFile") }}
                </button>
                <button
                  class="btn w-100 d-block"
                  v-on:click="uploadMenu = false"
                  :class="{
                    'btn-primary': !uploadMenu,
                    'btn-simple': uploadMenu,
                  }"
                >
                  {{ $t("videos.browseGallery") }}
                </button>
              </div>
              <div class="col" v-if="uploadMenu">
                <file-pond
                  name="video"
                  ref="pond"
                  label-idle="Drop files here..."
                  v-bind:allow-multiple="true"
                  accepted-file-types="video/mp4, video/avi, video/ogg, video/webm, video/quicktime, video/x-quicktime, video/x-msvideo"
                  v-bind:files="myFiles"
                  v-on:init="handleFilePondInit"
                  :server="server"
                  :chunkUploads="true"
                  :chunkForce="true"
                  :chunkSize="1000000"
                  :credits="false"
                />
              </div>
              <div class="col" v-else>
                <div class="row">
                  <div
                    class="col-3 my-2 img-uploader-thumbnail"
                    v-for="video in selectable"
                    :key="video.id"
                    v-on:click="addVideoToProduct(video)"
                  >
                    <img
                      class="img-thumbnail"
                      :src="mediaUrl + '/' + video.path + '/frame1.jpg'"
                      :alt="video.name"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="text-end mt-4">
              <button class="btn btn-primary" v-on:click="uploadWindow = false">
                {{ $t("videos.back") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";

import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import http from "../../modules/http";
import tenant from "../../modules/tenant";
const BaseIcon = defineAsyncComponent(() => import("../icons/BaseIcon.vue"));
const bootstrap = require("bootstrap");
import draggable from "vuedraggable";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

export default {
  name: "VideoEditor",
  props: {
    show: Boolean,
    id: Number,
    isVariant: Boolean,
    type: String,
  },
  computed: {
    mediaUrl() {
      return tenant.getAppVideoUrl();
    },
  },
  data: function () {
    return {
      uploadWindow: false,
      uploadMenu: true,
      myFiles: [],
      rows: [],
      selectable: [],
      selectedGroup: null,
      dragOptions: {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      },
      server: {
        process: this.upload,
        revert:
          process.env.VUE_APP_MEDIA_API +
          "/" +
          tenant.getTenantName() +
          "/videos/revert",
        restore:
          process.env.VUE_APP_MEDIA_API +
          "/" +
          tenant.getTenantName() +
          "/videos/restore",
        load:
          process.env.VUE_APP_MEDIA_API +
          "/" +
          tenant.getTenantName() +
          "/videos/load",
        fetch:
          process.env.VUE_APP_MEDIA_API +
          "/" +
          tenant.getTenantName() +
          "/videos/upload/a",
      },
    };
  },
  watch: {
    show() {
      let myModal = new bootstrap.Modal(this.$refs.modal, {
        backdrop: "static",
      });
      if (this.show) {
        myModal.show();
        if (this.type === "product") {
          if (this.isVariant) {
            http
              .fetch("/files/variant-videos?variant=" + this.id)
              .then((data) => {
                this.rows = [data.variant];
                this.selectable = data.product;
              });
          } else {
            http
              .fetch("/files/product-videos?product=" + this.id)
              .then((data) => {
                this.rows = data.images;
                this.selectable = data.related;
              });
          }
        }
      }
    },
  },
  methods: {
    deleteVideo(video) {
      let delVideo = {
        id: this.id,
        video: video.id,
      };

      if (this.isVariant) {
        delVideo.variant_id = this.id;
        delVideo.id = this.$parent.row.product_id;
      }

      http.fetch("/products/delete-video", delVideo).then(() => {
        let variantId = video.variant_id ?? 0;
        if (this.rows[variantId]) {
          let e = this.rows[variantId].images.indexOf(video);
          if (e > -1) {
            this.rows[variantId].images.splice(e, 1);
          }
        }
      });
    },
    selectDisplaySettings(video, type, active) {
      let addVideo = {
        id: this.id,
        video: video.id,
      };
      if (type === 1) {
        addVideo.in_meta = active;
        video.in_meta = active;
      } else if (type === 2) {
        addVideo.in_page = active;
        video.in_page = active;
      } else if (type === 3) {
        addVideo.in_manufacturing = active;
        video.in_manufacturing = active;
      }

      if (this.isVariant) {
        addVideo.variant_id = this.id;
        addVideo.id = this.$parent.row.product_id;
      }

      http.fetch("/products/display-video", addVideo).then(() => {});
    },
    selectSpotlight(video) {
      for (const videoElement of this.rows[video.variant_id ?? 0].images) {
        videoElement.main = false;
      }
      video.main = true;

      let addVideo = {
        id: this.id,
        video: video.id,
      };

      if (this.isVariant) {
        addVideo.variant_id = this.id;
        addVideo.id = this.$parent.row.product_id;
      }

      http.fetch("/products/primary-video", addVideo).then(() => {});
    },
    addVideoToProduct(video) {
      let addVideo = {
        id: this.id,
        video: video.id,
      };

      if (this.isVariant) {
        addVideo.variant_id = this.id;
        addVideo.id = this.$parent.row.product_id;
      }

      const group = this.selectedGroup;
      if (group && group.id) {
        addVideo.variant_id = group.id;
        this.rows[group.id].images.push(video);
      } else {
        this.rows[0].images.push(video);
      }

      this.uploadWindow = false;

      http.fetch(`/products/add-video`, addVideo);
    },
    moveEvent(groupId) {
      let addVideo = {
        id: this.id,
        images: this.rows[groupId ?? 0].images.map((e) => e.id),
      };
      if (groupId > 0) {
        addVideo.variant_id = groupId;
      }
      if (this.isVariant) {
        addVideo.variant_id = this.id;
        addVideo.id = this.$parent.row.product_id;
      }

      http.fetch(`/products/move-videos`, addVideo);
    },
    upload(
      fieldName,
      file,
      metadata,
      load,
      error,
      progress,
      abort,
      transfer,
      options
    ) {
      const _this = this;
      const request = new XMLHttpRequest();
      const group = _this.selectedGroup;

      let send = { type: this.type, id: _this.id, videos: [file.name] };
      if (_this.isVariant) {
        send.is_variant = true;
      }
      if (group) {
        send.variant_id = group.id;
      }

      http.fetch("/files/upload", send).then((data) => {
        const formData = new FormData();
        formData.append("token", data.token);
        formData.append("album", data.album);
        formData.append("category", this.type);

        request.open(
          "POST",
          process.env.VUE_APP_MEDIA_API +
            "/" +
            tenant.getTenantName() +
            "/videos/upload"
        );

        request.setRequestHeader("Upload-Length", file.size);
        request.setRequestHeader("Upload-Name", encodeURIComponent(file.name));

        request.upload.onprogress = (e) => {
          progress(e.lengthComputable, e.loaded, file.size);
        };

        request.onload = function () {
          if (request.status >= 200 && request.status < 300) {
            transfer(request.responseText);

            _this.chunkUpload(
              0,
              file,
              options,
              fieldName,
              data,
              progress,
              error,
              load,
              request.responseText
            );
          } else {
            error("oh no");
          }
        };

        request.send(formData);
      });

      return {
        abort: () => {
          request.abort();
          abort();
        },
      };
    },
    chunkUpload(
      start,
      file,
      options,
      fieldName,
      data,
      progress,
      error,
      load,
      fileId,
      i = 0
    ) {
      let _this = this;
      if (start < file.size) {
        let chunkEnd = Math.min(start + options.chunkSize, file.size);
        let chunkSize = chunkEnd - start;
        const chunk = file.slice(start, chunkEnd);

        const chunkForm = new FormData();
        chunkForm.append(fieldName, chunk, file.name);
        chunkForm.append("token", data.token);
        chunkForm.append("album", data.album);
        chunkForm.append("category", this.type);
        chunkForm.append("_method", "PATCH");

        const request = new XMLHttpRequest();

        request.open(
          "POST",
          process.env.VUE_APP_MEDIA_API +
            "/" +
            tenant.getTenantName() +
            "/videos/upload/" +
            fileId
        );

        request.setRequestHeader("Upload-Offset", start);
        request.setRequestHeader("Upload-Length", chunkSize);
        request.setRequestHeader("Upload-Name", encodeURIComponent(file.name));

        request.upload.onprogress = (e) => {
          progress(e.lengthComputable, start + e.loaded, file.size);
        };

        request.onload = function () {
          if (request.status >= 200 && request.status < 300) {
            _this.chunkUpload(
              chunkEnd,
              file,
              options,
              fieldName,
              data,
              progress,
              error,
              load,
              fileId
            );

            if (request.responseText?.length > 30) {
              let data2 = JSON.parse(request.responseText);

              let addVideo = {
                id: _this.id,
                video: data2.operation.videos[0].id,
              };

              if (_this.isVariant) {
                addVideo.variant_id = _this.id;
                addVideo.id = _this.$parent.row.product_id;
              }

              const group = _this.selectedGroup;
              if (group) {
                data2.operation.videos[0].variant_id = group.id;
              }

              if (group && group.id) {
                addVideo.variant_id = group.id;
                _this.rows[group.id].images.push(data2.operation.videos[0]);
              } else {
                _this.rows[0].images.push(data2.operation.videos[0]);
              }

              http.fetch(`/products/add-video`, addVideo);
            }
          } else {
            if (i >= options.chunkRetryDelays.length) {
              error("oh no");
            } else {
              setTimeout(() => {
                _this.chunkUpload(
                  start,
                  file,
                  options,
                  fieldName,
                  data,
                  progress,
                  error,
                  load,
                  fileId,
                  i + 1
                );
              }, options.chunkRetryDelays[i]);
            }
          }
        };

        request.send(chunkForm);
      } else {
        load();
      }
    },
    handleFilePondInit: function () {
      console.log("FilePond has initialized");
    },
  },
  components: { BaseIcon, FilePond, draggable },
};
</script>
